import { useMemo } from "react";
import TypeaheadInput from "../common/components/TypeaheadInput";
import { useResults } from "../reducers/resultSlice";
import PropTypes from 'prop-types';
import useClientConfig from "../common/hooks/clientConfigHook";

const ResultInput = ({ site, level, type, value, placeholder, hideLabel = false, disabled = false, required = false, onChange, live = false }) => {
    const clientConfig = useClientConfig();
    const results = useResults(site, level, type);
    const displayResults = useMemo(() => results.map(r => r.result), [results]);

    return <TypeaheadInput live={live} options={displayResults} value={value} placeholder={placeholder} disabled={disabled} required={required} onChange={result => onChange({ result })} hideLabel={hideLabel} maxLength={1024} lockdown={!!clientConfig.lockdownResults}></TypeaheadInput>
}
ResultInput.propTypes = {
    site: PropTypes.string,
    level: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    hideLabel: PropTypes.bool,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    onChange: PropTypes.func,
    live: PropTypes.bool
}

export default ResultInput;